
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_status",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Status')
        },
        value() {
            let status = ''
            if (this.unitLmsgStatus?.isMoving) {
                status = this.$t('Units.movements.Moving')
            } else
            // if (this.unitLmsgStatus?.ignition) {
            //     status = this.$t('Units.movements.Ignition on')
            // } else
            if (this.unitLmsgStatus?.isParked) {
                status = this.$t('Units.movements.Stopped')
            }

            return status
        },
        statusClass(){
            let timeAgo = this.unitLmsgTimeAgo
            if (!timeAgo && timeAgo !== 0) {
                return '';
            }
            //if(timeAgo<0) timeAgo *= -1

            if (timeAgo <= this.$consts.status.online) {
                return 'update_status_online'
            } else if (timeAgo > this.$consts.status.offline) {
                return 'update_status_not-online-long-time'
            } else {
                return 'update_status_online-recently'
            }
        },
        statusIcon(){
            let timeAgo = this.unitLmsgTimeAgo
            return  timeAgo <= this.$consts.status.offline ? 'status_online' : 'status_offline'
        },
        icon() {
            return this.showIcon ? 'car_' : false
        }
    },
}
</script>

<style scoped>

</style>